/**
 * Configurações de fontes do Sistema MEDICARE
 */

export const fonts = {
  // Fonte principal para textos
  body: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`,
  
  // Fonte para cabeçalhos
  heading: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`,
  
  // Fonte monoespaçada para código
  mono: `'Fira Code', 'Monaco', 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace`,
};

// Tamanhos de fonte customizados
export const fontSizes = {
  '2xs': '0.625rem',   // 10px
  xs: '0.75rem',       // 12px
  sm: '0.875rem',      // 14px
  md: '1rem',          // 16px
  lg: '1.125rem',      // 18px
  xl: '1.25rem',       // 20px
  '2xl': '1.5rem',     // 24px
  '3xl': '1.875rem',   // 30px
  '4xl': '2.25rem',    // 36px
  '5xl': '3rem',       // 48px
  '6xl': '3.75rem',    // 60px
  '7xl': '4.5rem',     // 72px
  '8xl': '6rem',       // 96px
  '9xl': '8rem',       // 128px
};

// Pesos de fonte
export const fontWeights = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900,
};

// Alturas de linha
export const lineHeights = {
  normal: 'normal',
  none: 1,
  shorter: 1.25,
  short: 1.375,
  base: 1.5,
  tall: 1.625,
  taller: '2',
  '3': '.75rem',
  '4': '1rem',
  '5': '1.25rem',
  '6': '1.5rem',
  '7': '1.75rem',
  '8': '2rem',
  '9': '2.25rem',
  '10': '2.5rem',
};

// Espaçamento entre letras
export const letterSpacings = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em',
};

// Estilos de texto customizados
export const textStyles = {
  // Títulos principais
  h1: {
    fontSize: ['2xl', '3xl', '4xl'],
    fontWeight: 'bold',
    lineHeight: 'shorter',
    letterSpacing: 'tight',
  },
  h2: {
    fontSize: ['xl', '2xl', '3xl'],
    fontWeight: 'semibold',
    lineHeight: 'short',
    letterSpacing: 'tight',
  },
  h3: {
    fontSize: ['lg', 'xl', '2xl'],
    fontWeight: 'semibold',
    lineHeight: 'short',
  },
  h4: {
    fontSize: ['md', 'lg', 'xl'],
    fontWeight: 'medium',
    lineHeight: 'base',
  },
  
  // Textos de corpo
  body: {
    fontSize: 'md',
    fontWeight: 'normal',
    lineHeight: 'base',
  },
  bodyLarge: {
    fontSize: 'lg',
    fontWeight: 'normal',
    lineHeight: 'base',
  },
  bodySmall: {
    fontSize: 'sm',
    fontWeight: 'normal',
    lineHeight: 'base',
  },
  
  // Textos especiais
  caption: {
    fontSize: 'xs',
    fontWeight: 'normal',
    lineHeight: 'base',
    color: 'gray.600',
  },
  overline: {
    fontSize: 'xs',
    fontWeight: 'semibold',
    lineHeight: 'base',
    textTransform: 'uppercase',
    letterSpacing: 'wide',
  },
  
  // Textos de interface
  button: {
    fontSize: 'sm',
    fontWeight: 'medium',
    lineHeight: 'base',
  },
  label: {
    fontSize: 'sm',
    fontWeight: 'medium',
    lineHeight: 'base',
  },
  input: {
    fontSize: 'md',
    fontWeight: 'normal',
    lineHeight: 'base',
  },
  
  // Textos médicos específicos
  diagnostico: {
    fontSize: 'md',
    fontWeight: 'semibold',
    lineHeight: 'base',
    color: 'medicare.700',
  },
  prescricao: {
    fontSize: 'sm',
    fontWeight: 'medium',
    lineHeight: 'tall',
    fontFamily: 'mono',
  },
  observacoes: {
    fontSize: 'sm',
    fontWeight: 'normal',
    lineHeight: 'tall',
    fontStyle: 'italic',
  },
};